<template>
  <div class="box">
    <img
      src="../../../../assets/images/bg-top@2x.png"
      alt=""
      class="header-img"
    />
    <div class="content">
      <div class="no_club" v-if="row.club_list.length == 0">
        <div style="height: 3.56rem"></div>
        <div style="display: flex; justify-content: space-between;">
        <div class="create_btn" @click="toClub">立即创建</div>
        <!-- <div class="create_btn" @click="toBindClub">从原CCA官网同步俱乐部</div> -->
        </div>
      </div>
      <div class="club" v-if="row.club_list.length > 0">
        <h1>{{ row.club.name }}</h1>
        <div class="level">
          <h1>俱乐部等级</h1>
          <img
            v-if="row.club.bgrade == '一星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '二星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '二星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '三星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '三星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '三星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
        </div>
        <div class="br"></div>
        <h2>俱乐部人员情况</h2>
        <div class="club_detail">
          <div class="detail_info">
            <h1>{{ row.club.member.total }}</h1>
            <h2>总人数</h2>
          </div>
          <div class="detail_info">
            <h1>{{ row.club.member.add_member }}</h1>
            <h2>今年新增人数</h2>
          </div>
          <div class="detail_info">
            <h1>{{ row.club.member.activity_member }}</h1>
            <h2>今年参与活动人数</h2>
          </div>
        </div>
        <div class="br" style="margin-top: 0.4rem"></div>
        <div class="my_detail" v-show="row.club.list.length>0">
          <h2>我的活动&比赛</h2>
          <div v-for="(item, index) in row.club.list" :key="index" v-rblink="{
                    'name' : 'ISaiApplyDetail',
                    'query':{
                        id: item.id
                    }}">
            <div class="br"></div>
            <div class="list_header">
              <h1>{{ item.saiqu_name }}</h1>
              <div class="action_btn">继续操作</div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between">
          <div class="btn" @click="goClub">管理俱乐部</div>
          <div class="btn"  @click.stop="sheetActiveShow=true">切换俱乐部</div>
          <div class="btn" @click.stop="unbindClub()">解除绑定</div>
        </div>
      </div>
      <div
        class="no_grade"
        style="margin-top: 0.3rem"
        v-if="row.center_list.length == 0"
      >
        <div style="height: 3.56rem"></div>
        <div class="create_btn" @click="toKaoji">立即创建</div>
      </div>
      <div
        class="club"
        style="margin-top: 0.3rem"
        v-if="row.center_list.length > 0"
      >
        <h1>{{ row.center.danwei }}</h1>
        <div class="icon">{{ row.center.kaojitype }}</div>
        <div class="br"></div>
        <h2>考级中心/点人员情况</h2>
        <div class="club_detail">
          <div class="detail_info">
            <h1>{{ row.center.member.total }}</h1>
            <h2>总人数</h2>
          </div>
          <div class="detail_info">
            <h1>{{ row.center.member.add_member }}</h1>
            <h2>今年新增人数</h2>
          </div>
          <div class="detail_info">
            <h1>{{ row.center.member.activity_member }}</h1>
            <h2>今年参与活动人数</h2>
          </div>
        </div>
        <div class="br" style="margin-top: 0.4rem"></div>
        <div class="my_detail" v-show="row.center.list.length>0">
          <h2>我的考级</h2>
          <div v-for="(item, index) in row.center.list" :key="index"  v-rblink="{
            name:'ExameApplyDetailMine',
            query:{
              id:item.id
            }
          }">
            <div class="br"></div>
            <div class="list_header">
              <h1>{{ item.saiqu_name }}</h1>
              <div class="action_btn">继续操作</div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between">
          <div
            class="btn"
            style="width: 100px"
            @click="goCenter" 
          >
            管理考级中心
          </div>
          <div class="btn" @click.stop="centerActiveShow=true">切换考级中心</div>
          <div class="btn" @click.stop="unbindCenter()">解除绑定</div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="clubShow"
      title=""
      class="dialog-box"
      :showConfirmButton="false"
    >
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <!-- <div class="dialog-step-li">
          1.首次申请，默认成为一星俱乐部，如需升级星级详见俱乐部申报流程；
        </div>

        <div class="dialog-step-li">2.俱乐部升级类别</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）二星俱乐部</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）三星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）四星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）五星俱乐部</div>
          </li>
        </ul> -->

        <!--        <div class="dialog-step-li">3.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>-->
        <div class="dialog-step-li">
          附件下载
          <!--          <div class="dialog-step-li-text"-->
          <!--               @click="download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')">-->
          <!--            啦啦操星级俱乐部管理办法-->
          <!--          </div>-->
          <div>
            <van-button
              type="primary"
              @click="
                download(
                  '啦啦操星级俱乐部管理办法',
                  'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf'
                )
              "
            >
              啦啦操星级俱乐部管理办法
            </van-button>
          </div>
        </div>

        <van-button type="primary" size="large" @click="toClubNext(0)">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="clubShow = false"
          >我再想想</van-button
        >
      </div>
    </van-dialog>
    <van-dialog
      v-model="kaojiShow"
      title=""
      class="dialog-box"
      :showConfirmButton="false"
    >
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <div class="dialog-step-li">1.可创建类型为：</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）七彩星级指定考级点</div>
            <div class="li-right">0元</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）七彩星级指定样板考级点</div>
            <div class="li-right">9800元</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）七彩星级指定考级中心</div>
            <div class="li-right">120000元</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）七彩星级指定样板考级中心</div>
            <div class="li-right">135000元</div>
          </li>
        </ul>

        <div class="dialog-step-li">
          2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/
        </div>

        <div class="dialog-step-li">
          3.附件下载
          <div
            class="dialog-step-li-text"
            @click="
              download(
                '啦啦操七彩星级管理办法',
                'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf'
              )
            "
          >
            啦啦操七彩星级管理办法
          </div>
          <div
            class="dialog-step-li-text"
            @click="
              download(
                '七彩星级考级中心（点）加盟方案',
                'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf'
              )
            "
          >
            七彩星级考级中心（点）加盟方案
          </div>
          <!--          <div class="dialog-step-li-text"-->
          <!--               @click="download('考级点文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip')">-->
          <!--            考级点文化包（兼容版）请下载制作-->
          <!--          </div>-->
          <!--          <div class="dialog-step-li-text"-->
          <!--               @click="download('考级中心文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip')">-->
          <!--            考级中心文化包（兼容版）请下载制作-->
          <!--          </div>-->
        </div>

        <van-button type="primary" size="large" @click="toKaojiNext(0)">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="kaojiShow = false"
          >我再想想</van-button
        >
      </div>
    </van-dialog>
    <van-action-sheet
      v-model="sheetActiveShow"
      description="将以新的俱乐部主体参赛报名"
      :actions="row.club_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelect"
    />

    <van-action-sheet
      v-model="centerActiveShow"
      description="将以考级中心/点申报考级"
      :actions="row.center_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelectCenter"
    />
     <div class="savebtn">
      <van-button 
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round
          @click="toClub">创建俱乐部
      </van-button>

      <van-button 
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round @click="toKaoji">创建考级中心（点）
      </van-button>
    </div>
  </div>
</template>
<style scoped>
.box {
  height: 100%;
  overflow: scroll;
  padding-bottom: 2rem;
  background: #f0eff4;
}
.content {
  padding: 0.2rem;
  padding-top: 0.3rem;
}
.header-img {
  width: 100%;
  height: 2.76rem;
}
.club {
  /* height: 5.1rem; */
  background: #ffffff;
  border-radius: 10px;
  position: relative;
  top: -0.8rem;
  padding: 0.3rem;
}
.club h1 {
  font-size: 0.42rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  line-height: 0.6rem;
}
.level {
  display: flex;
  margin-top: 0.1rem;
}
.level h1 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.4rem;
}
.level img {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.1rem;
}
.br {
  height: 1px;
  background: #ebedf0;
  margin-top: 0.2rem;
}
.club h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.4rem;
}
.club_detail {
  display: flex;
  text-align: center;
  justify-content: space-between;
  margin-top: 0.4rem;
  padding-left: 0.16rem;
}
.detail_info h1 {
  font-size: 0.42rem;
  font-family: DINCond-Black, DINCond;
  font-weight: 900;
  color: #333333;
  line-height: 0.5rem;
}
.detail_info h2 {
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.34rem;
  margin-top: 0.08rem;
}
.btn {
  width: 1.72rem;
  height: 0.64rem;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.64rem;
  text-align: center;
  margin-top: 0.4rem;
}
.icon {
  width: 1.32rem;
  height: 0.42rem;
  background: linear-gradient(270deg, #f4faff 0%, #84caff 100%);
  border-radius: 11px;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.42rem;
  text-align: center;
  margin-top: 0.12rem;
}
.no_club {
  height: 4.72rem;
  background-image: url("../../../../assets/images/bg-weijiarujulebu@2x.png");
  background-size: 100% 100%;
}
.create_btn {
  min-width: 86px;
  padding: 0 10px;
  height: 32px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
}
.no_grade {
  height: 4.72rem;
  background-image: url("../../../../assets/images/bg-weijiarukaoji@2x.png");
  background-size: 100% 100%;
}
.dialog-head {
  font-size: 0.5rem;
  font-weight: 700;
  text-align: center;
  padding: 0.4rem 0 0.3rem;
}

.dialog-content {
  padding: 0 0.3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: 0.2rem 0 0.3rem;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
.my_detail h2 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.4rem;
}
.list_header {
  display: flex;
  justify-content: space-between;
  margin-top: 0.3rem;
}
.list_header h1 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 0.4rem;
  margin-left: 0.3rem;
  line-height: 28px;
}
.action_btn {
  width: 1.36rem;
  height: 0.56rem;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 0.46rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.56rem;
  text-align: center;
  margin-right: 0.3rem;
}
</style>
<script>
import Vue from "vue";
// import area from "../../../utils/area";
// import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Dialog)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "MyClub",
  components: {
    PicUploader,
    LoginDialog,
  },
  data: function () {
    return {
      loading: true,
       sheetActiveShow:false, 
      centerActiveShow:false, 
      saveLoading: false,
      loginShow: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      clubShow: false,
      kaojiShow: false,
      submitType: "",
      row: {
        club_list:[],
        center_list:[],
        danwei: {},
        cert: {},
      },
      formData: {},
      max1: 2,
      max2: 2,
      max3: 2,
      max1show: true,
      max2show: true,
      max3show: true,
    };
  },
  filters: {},
  mounted() {
    document.title = "我的俱乐部";
    let that = this;
    this.fetch();
  },
  watch: {},
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },

    toJiaolian() {
      if (this.row.cert.status) {
        rbLink({
          name: "UserSearchJiaolian",
        });
      } else {
        Toast("请先进行实名认证");
        setTimeout(function () {
          rbLink({
            name: "CertIndex",
          });
        }, 200);
      }
    },
    unbindClub() {
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "确认要解除绑定该俱乐部吗?",
      })
        .then(() => {
          that.$api.post(
            "/api/club/clubUserUnBind",
            {
              club_id: that.row.club.id,
            },
            (res) => {
              that.fetch();
            },
            (res) => {}
          );

          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
    },
    unbindCenter() {
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "确认要解除绑定该考级中心/点吗?",
      })
        .then(() => {
          that.$api.post(
            "/api/examecenter/centerUserUnBind",
            {
              center_id: that.row.center.id,
            },
            (res) => {
              that.fetch();
            },
            (res) => {}
          );

          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
    },
    // 解绑
    unbind() {
      let that = this;

      Dialog.confirm({
        title: "解绑",
        message: "确定解绑吗?",
      })
        .then(() => {
          // on confirm
          that.$api.get(
            "/api/club/clubUserUnBind",
            {
              club_id: that.row.id,
            },
            (res) => {
              Toast.success("解绑成功");
              rbLink(
                {
                  name: "ClubSearchIndex",
                },
                "back"
              );
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    max1change() {
      this.max1 = 10000;
      this.max1show = false;
    },
    max2change() {
      this.max2 = 10000;
      this.max2show = false;
    },
    max3change() {
      this.max3 = 10000;
      this.max3show = false;
    },
    toClub() {
      this.clubShow = true;
    },

    toKaoji() {
      this.kaojiShow = true;
    },

    toCaipan() {
      if (this.row.cert.status) {
        rbLink({
          name: "UserSearchCaipan",
        });
      } else {
        Toast("请先进行实名认证");
        setTimeout(function () {
          rbLink({
            name: "CertIndex",
          });
        }, 200);
      }
    },
    toBindClub(){
        rbLink(
          {
            name: "ClubBind",
            query: {},
          },
          "replace"
        );
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/user/myclub",
        {},
        (res) => {
          that.row = res.data;
          that.loading = false;
        },
        (res) => {
          that.loading = false;
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    // 创建俱乐部
    toClubNext(id) {
      rbLink({
        name: "ClubApplyMine",
        query: {
          id: id,
        },
      });
    },

    // 创建考级中心/点
    toKaojiNext(id) {
      rbLink({
        name: "QcxjStationApplyMine",
        query: {
          id: id,
        },
      });
    },
    // 官网已有考级中心认证
    toAuth() {
      rbLink({
        name: "QcxjStationBind",
      });
    },
    // 下载附件
    download(name, url) {
      appEvent({
        name: "downloadFile",
        query: {
          name: name,
          url: url,
        },
      });
    },
     goClub(){
      rbLink({name:'ClubDetail', query: {id: this.row.club.id}});
    },
    goCenter(){
      rbLink({name:'QcxjDetail', query: {id: this.row.center.id}});
    },
    onSelect(action,index){
      console.log(action,index)   
      let that = this;
      that.$api.post('/api/club/clubChange', {
        club_id  : action.id
      }, (res) => { 
          Toast('您的俱乐部已切换成【'+ action.name+'】');
          that.fetch();
      }, (res) => { 
      })
    },

    onSelectCenter(action,index){
      console.log(action,index)   
      let that = this;
      that.$api.post('/api/examecenter/centerChange', {
        center_id  : action.id
      }, (res) => { 
          Toast('您的考级中心/点已切换成【'+ action.name+'】');
          that.fetch();
      }, (res) => { 
      })
    },
    onSheetCancel() {
      // Toast('取消');
    },
  },
};
</script>



// WEBPACK FOOTER //
// MyClub.vue?13834382